import React, { FunctionComponent, useEffect, useState } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';

import 'intersection-observer';

export interface IntersectionTrackerProps extends FlexProps<'div'> {
  root?: HTMLElement | null;
  focus?: boolean;
  threshold?: number[];
  onIntersection?: (intersection?: number) => void;
}

const defaultThresholds = [0, 0.33, 0.66, 0.99];

const IntersectionTracker: FunctionComponent<IntersectionTrackerProps> = (props) => {
  const { onIntersection, focus, threshold = defaultThresholds, root, ...other } = props;
  const [ref, setRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (ref) {
      const observer = new IntersectionObserver(
        (entries) => {
          onIntersection?.(entries?.[0]?.intersectionRatio);
        },
        { threshold, root }
      );

      observer.observe(ref);
      return () => observer.disconnect();
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, root]);

  useEffect(() => {
    if (focus) {
      ref?.scrollIntoView?.({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }, [focus, ref, onIntersection]);

  return <Flex ref={setRef} data-focused={focus} {...other} />;
};

export default IntersectionTracker;
